module.exports = __webpack_public_path__ + "b40f44c6f2d10077d434011b04e1ca5e.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/hand/crayons-s.png
// module id = 2624
// module chunks = 0